module.exports = "<div class='proxying-customer-info-panel__wrapper'>\n  Proxy for #{{vm.getCustomerInfo('id','name')}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/proxyingCustomerInfoPanel/proxyingCustomerInfoPanel.html
// module id = 520
// module chunks = 1